"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.modalStateFactory = void 0;
var modals_1 = __importDefault(require("@dtna/dvs-core-dcp-client-constants/lib/constants/modals"));
var modalStateFactory = function (config) { return (__assign({ activeModal: modals_1.default.NONE }, config)); };
exports.modalStateFactory = modalStateFactory;
